import React from "react";
import { Typography, List, ListItem, Button } from "@mui/material";
import { ExternalLink } from "components/navigation";
import MenuBookIcon from "@mui/icons-material/MenuBook";

const GettingStarted = () => (
  <React.Fragment>
    <Typography variant="h5" gutterBottom>
      Getting Started
    </Typography>
    <Typography gutterBottom>
      Cinnamon is an efficient reusable framework for developing React single
      page apps using MUI.
    </Typography>
    <Typography>
      It is built upon the latest versions of the following libraries:
    </Typography>
    <List>
      <ListItem disableGutters>
        <ExternalLink href="https://mui.com/">MUI</ExternalLink>
      </ListItem>
      <ListItem disableGutters>
        <ExternalLink href="https://reactrouter.com/">
          React Router
        </ExternalLink>
      </ListItem>
      <ListItem disableGutters>
        <ExternalLink href="https://redux.js.org/">Redux</ExternalLink>
      </ListItem>
      <ListItem disableGutters>
        <ExternalLink href="https://moment.github.io/luxon">Luxon</ExternalLink>
      </ListItem>
    </List>
    <Typography mt={2} gutterBottom>
      For a further introduction to Cinnamon and guidance on best practices for
      front-end development, please visit the wiki:
    </Typography>
    <Button
      variant="contained"
      component={ExternalLink}
      href="https://github.com/RedRiverSoftware/Cinnamon/wiki"
      startIcon={<MenuBookIcon />}
    >
      Cinnamon Wiki
    </Button>
  </React.Fragment>
);

export default GettingStarted;
